import type { Content } from '../../models';

import { VisualsWithDataTypes } from '../../config/constants';

export const validateContentVersion66 = (content: Content): boolean => {
  const { type, typeSpecific } = content;

  if (typeSpecific.version < 66) {
    if (VisualsWithDataTypes.includes(type) && typeSpecific.chart?.bars.customBars) {
      // Normalize customBars[]
      for (const bar of typeSpecific.chart.bars.customBars) {
        bar.image.positionMode = bar.image.positionMode ?? 'flow';
        bar.image.style.margin = bar.image.style.margin ?? {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        };
      }
    }

    typeSpecific.version = 66;
  }

  return true;
};
